export const SOURCE_LABELS = {
  shopmyshelf: 'ShopMy',
  cj: 'CJ',
  rakuten: 'Rakuten',
  impact: 'Impact',
  awin: 'Awin',
  skimlink: 'Skimlinks',
  tradedoubler: 'TradeDoubler',
  amazon: 'Amazon'
};

// Networks whose nightly payloads land in S3 and feed MerchantCommissionDisclaimers.
export const SNAPSHOT_SOURCES = ['impact', 'cj', 'rakuten', 'awin'];

export const getSourceLabel = source => SOURCE_LABELS[source] || source.charAt(0).toUpperCase() + source.slice(1);
export const getSourceTagClass = source => (SOURCE_LABELS[source] ? source : 'other');

export const formatMerchantRate = merchant => {
  if (merchant.fullPayout === null || merchant.fullPayout === undefined) return null;
  return merchant.rateType === 'fixed_fee' ? `$${merchant.fullPayout}` : `${merchant.fullPayout}%`;
};
